var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cx-category-api-header"},[_c('div'),_vm._v(" "),_vm._l((_vm.getTimeFrames),function(frame,index){return _c('div',{key:index,staticClass:"local-header-text"},[_vm._v("\n    "+_vm._s(frame))])}),_vm._v(" "),_c('div')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }